/*
 * HUD layout from spec §6.2: a top status bar, a left advisor rail, a right
 * inspector, and a bottom tool bar around the 3D viewport.
 */

.root {
  position: fixed;
  inset: 0;
  display: grid;
  grid-template-rows: 2.75rem 1fr 3.25rem;
  grid-template-columns: 15rem 1fr 17rem;
  grid-template-areas:
    'top top top'
    'advisors viewport inspector'
    'tools tools tools';
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    'Segoe UI',
    sans-serif;
  font-size: 0.8125rem;
  color: #e8ecef;
  pointer-events: none;
}

.panel {
  background: rgb(22 27 32 / 88%);
  border: 1px solid rgb(255 255 255 / 8%);
  pointer-events: auto;
}

.top {
  grid-area: top;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 0 1rem;
}

.brand {
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-right: auto;
}

.stat {
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
  white-space: nowrap;
}

.statLabel {
  color: #93a1ad;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.statValue {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.unit {
  color: #93a1ad;
  font-weight: 400;
}

.speeds {
  display: flex;
  gap: 0.25rem;
}

.speedButton {
  background: rgb(255 255 255 / 6%);
  border: 1px solid rgb(255 255 255 / 10%);
  border-radius: 0.25rem;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0.25rem 0.625rem;
}

.speedButton:hover {
  background: rgb(255 255 255 / 12%);
}

.speedButtonActive {
  background: #2f6f8f;
  border-color: #4b93b5;
}

.advisors {
  grid-area: advisors;
  margin: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  align-self: start;
}

.inspector {
  grid-area: inspector;
  margin: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  align-self: start;
}

.panelTitle {
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #93a1ad;
  margin: 0 0 0.5rem;
}

.rows {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.25rem 0.75rem;
}

.rowLabel {
  color: #b6c2cc;
}

.rowValue {
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.note {
  color: #93a1ad;
  line-height: 1.45;
  margin: 0.5rem 0 0;
}

.tools {
  grid-area: tools;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0 0.75rem;
}

.tool {
  background: rgb(255 255 255 / 6%);
  border: 1px solid rgb(255 255 255 / 10%);
  border-radius: 0.25rem;
  color: inherit;
  font: inherit;
  padding: 0.4375rem 0.75rem;
}

.tool:disabled {
  color: #6d7a85;
  cursor: not-allowed;
}

.toolLock {
  color: #6d7a85;
  font-size: 0.6875rem;
  margin-left: 0.375rem;
}

.meter {
  width: 4.5rem;
  height: 0.5rem;
  border: 1px solid rgb(255 255 255 / 20%);
  border-radius: 0.25rem;
  overflow: hidden;
}

.meterFill {
  height: 100%;
  background: #4b93b5;
}
